import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import classNames from 'classnames';
import { isObject, isUndefined } from 'lodash';
import { breakpointInfix } from './breakpoints';
import { Enum } from './enum';
export var DisplayType = Enum({
  block: 'block',
  inline: 'inline',
  inlineBLock: 'inline-block',
  flex: 'flex',
  flexInline: 'flex-inline',
  none: 'none',
  table: 'table',
  tableCell: 'table-cell',
  tableRow: 'table-row'
});
export function getDisplayClass(type) {
  var respObj = isObject(type) ? type : {
    xs: type
  };
  var classes = Object.keys(respObj).reduce(function (acc, bp) {
    var val = respObj[bp];
    if (isUndefined(val)) return acc;
    return [].concat(_toConsumableArray(acc), ["d--".concat(DisplayType[val]).concat(breakpointInfix(bp))]);
  }, []);
  return classNames(classes);
}